export default {
  getWebsiteInfoConfigMut(state, payload) {
    state.WebsiteInfoConfig = payload
  },
  getWebsitePageConfigMut(state, payload) {
    state.WebsitePageConfig = payload
  }


}